import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import { customerContractsReducer } from "../features/customer/customerContractsSlice";
import { customerCostCentersReducer } from "../features/customer/customerCostCentersSlice";
import { customerOrganizationListReducer } from "../features/customer/customerOrganizationListSlice";
import { customerOrganizationReducer } from "../features/customer/customerOrganizationSlice";
import { customerOrganizationsReducer } from "../features/customer/customerOrganizationsSlice";
import { customerUsersReducer } from "../features/customer/customerUsersSlice";
import { customerWorkLocationsReducer } from "../features/customer/customerWorkLocationsSlice";
import { orderTemplatesReducer } from "../features/customer/orderTemplatesSlice";
import { tesReducer } from "../features/customer/tesSlice";
import { dashboardReducer } from "../features/dashboard/slice/dashboardSlice";
import { employmentReducer } from "../features/employment/employmentSlice";
import entriesReducer from "../features/entries/entriesSlice";
import { feedbacksReducer } from "../features/feedbacks/FeedbacksSlice";
import invoiceDetailedReducer from "../features/invoices/invoiceDetailedSlice";
import { userMessagesReducer } from "../features/userMessages/userMessagesSlice";
import invoiceReducer from "../features/invoices/invoiceSlice";
import jobAdReducer from "../features/jobAds/jobAdSlice";
import jobAdApplicantsSlice from "../features/jobAds/jodAdApplicants/jobAdApplicantsSlice";
import languageSkillsReducer from "../features/languageSkills/languageSkillsSlice";
import localizedReducer from "../features/localized/localizedSlice";
import { messageReducer } from "../features/message/messageSlice";
import { messagingReducer } from "../features/messaging/messagingSlice";
import { orderBundleCommentsReducer } from "../features/orders/orderBundleCommentsSlice";
import { orderRowsDetailedReducer } from "../features/orders/orderRowsDetailedSlice";
import { orderRowsReducer } from "../features/orders/orderRowsSlice";
import { talentsStatusReducer } from "../features/orders/talentsStatusSlice";
import { workOffersReducer } from "../features/orders/workOffersSlice";
import calendarReducer from "../features/talentProfile/calendar/calendarSlice";
import { employerHealthInsuranceReductionsReducer } from "../features/salaries/employerHealthInsuranceReduction/employerHealthInsuranceReductionsSlice";
import payslipReducer from "../features/salaries/payslips/payslipsSlice";
import wageReportReducer from "../features/salaries/wageReports/wageReportsSlice";
import { recruitmentsReducer } from "../features/settings/recruitment/recruitmentsSlice";
import { messageTemplatesReducer } from "../features/settings/messages/messagesSlice";
import { unionsReducer } from "../features/settings/Unions/unionsSlice";
import skillReducer from "../features/skills/skillsSlice";
import { supplementsReducer } from "../features/supplements/supplementsSlice";
import { talentCommentsReducer } from "../features/talentProfile/comments/TalentCommentsSlice";
import { assignmentsReducer } from "../features/talentProfile/Employment/AssignmentAdditionalInfo/AssignmentsSlice";
import { paymentProhibitionsReducer } from "../features/talentProfile/Employment/PaymentProhibition/paymentProhibitionSlice";
import { taxWithholdingCorrectionsReducer } from "../features/talentProfile/Employment/WitholdingTaxCorrection/taxWithholdingCorrectionSlice";
import { talentsListReducer } from "../features/talents/talentsListSlice";
import { talentsReducer } from "../features/talents/talentsSlice";
import { talentTagsReducer } from "../features/talentTags/talentTagsSlice";
import { tesSalaryComponentsReducer } from "../features/tesSalaryComponents/tesSalaryComponentsSlice";
import { tesSalaryTablesReducer } from "../features/tesSalaryTables/tesSalaryTablesSlice";
import { expertUsersReducer } from "../features/user/expertUsersSlice";
import userReducer from "../features/user/userSlice";
import { workhistoriesReducer } from "../features/workHistory/WorkHistoriesSlice";
import workTitleReducer from "../features/workTitles/workTitleSlice";
import { appReducer } from "./appSlice";
import { errorLogger } from "./middleware";
import announcementReducer from "../features/settings/announcements/announcementSlice";

export const store = configureStore({
  reducer: {
    app: appReducer,
    user: userReducer,
    entries: entriesReducer,
    message: messageReducer,
    orderRows: orderRowsReducer,
    orderRowsDetailed: orderRowsDetailedReducer,
    orderBundleComments: orderBundleCommentsReducer,
    invoices: invoiceReducer,
    invoicesDetailed: invoiceDetailedReducer,
    workTitles: workTitleReducer,
    skills: skillReducer,
    languageSkills: languageSkillsReducer,
    talents: talentsReducer,
    talentsList: talentsListReducer,
    talentsStatus: talentsStatusReducer,
    assignments: assignmentsReducer,
    dashboard: dashboardReducer,
    workHistories: workhistoriesReducer,
    talentComments: talentCommentsReducer,
    customerUsers: customerUsersReducer,
    expertUsers: expertUsersReducer,
    localized: localizedReducer,
    employment: employmentReducer,
    customerOrganizations: customerOrganizationsReducer,
    customerOrganization: customerOrganizationReducer,
    customerOrganizationList: customerOrganizationListReducer,
    customerCostCenters: customerCostCentersReducer,
    customerContracts: customerContractsReducer,
    customerWorkLocations: customerWorkLocationsReducer,
    orderTemplates: orderTemplatesReducer,
    talentTags: talentTagsReducer,
    tes: tesReducer,
    payslips: payslipReducer,
    workOffers: workOffersReducer,
    wageReports: wageReportReducer,
    unions: unionsReducer,
    paymentProhibitions: paymentProhibitionsReducer,
    taxWithholdingCorrections: taxWithholdingCorrectionsReducer,
    jobAds: jobAdReducer,
    jobAdApplicants: jobAdApplicantsSlice,
    supplements: supplementsReducer,
    tesSalaryComponents: tesSalaryComponentsReducer,
    tesSalaryTables: tesSalaryTablesReducer,
    recruitments: recruitmentsReducer,
    messageTemplates: messageTemplatesReducer,
    employerHealthInsuranceReductions: employerHealthInsuranceReductionsReducer,
    feedbacks: feedbacksReducer,
    messaging: messagingReducer,
    calendar: calendarReducer,
    userMessages: userMessagesReducer,
    announcements: announcementReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(errorLogger),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
